module.exports = __webpack_public_path__ + "static/media/8-Clubs.2d7db771.svg";